import { generateGuestGuid } from '@/utils/utils';
import { defineStore } from 'pinia';

interface UserState {
  cartNum: number;
  shopId?: number;
  shopName?: string;
  tableId?: number;
  tableName?: string;
  qrCode?: string;
  customerId?: number;
  customerName?: string;
  cartType?: number;
  currentOrderId?: number;
  paymentType?: number;
}

const useMainStore = defineStore('main', {
  // 相当于私有变量
  state: (): UserState => ({
    cartNum: 0,
    shopId: 1,
    shopName: '茂阁荟【美食集市】',
    tableId: undefined,
    tableName: undefined,
    qrCode: undefined,
    customerId: undefined,
    customerName: undefined,
    cartType: undefined, //1合并购物车、2独立购物车
    currentOrderId: undefined,
    paymentType: undefined, //支付类型：0后付款、1先付款
  }),
  getters: {
    // 属性访问
    getCartNum(): number {
      return this.cartNum;
    },
    getCartType(): number {
      let cartType = this.cartType;
      if (!cartType) {
        cartType = Number(localStorage.getItem('cartType') || 0);
      }
      return cartType || 0;
    },
    // getCarTag(state): string {
    //   return state.cartType === 1
    //     ? state.shopName + '-' + state.tableName
    //     : state.customerName || '';
    // },
    getShopId(): number {
      let shopId = this.shopId;
      if (!shopId) {
        shopId = Number(localStorage.getItem('shopId') || 0);
      }
      return shopId || 0;
    },
    getShopName(): string {
      let shopName = this.shopName;
      if (!shopName) {
        shopName = localStorage.getItem('shopName') || '';
      }
      return shopName || '';
    },
    getTableId(): number {
      let tableId = this.tableId;
      if (!tableId) {
        tableId = Number(localStorage.getItem('tableId') || 0);
      }
      return tableId || 0;
    },
    getTableName(): string {
      let tableName = this.tableName;
      if (!tableName) {
        tableName = localStorage.getItem('tableName') || '';
      }
      return tableName || '';
    },
    getQrCode(): string {
      let qrCode = this.qrCode;
      if (!qrCode) {
        qrCode = localStorage.getItem('qrCode') || '';
      }
      return qrCode || '';
    },
    getcustomerId(): number {
      return this.customerId || 0;
    },
    getcustomerName(): string {
      let customerName = this.customerName;
      if (!customerName) {
        const tempCustomerStr = localStorage.getItem('temp-customer') || '';
        if (tempCustomerStr) {
          const tempCustomer = JSON.parse(tempCustomerStr);
          customerName = tempCustomer.value;
        } else {
          this.customerName = customerName = generateGuestGuid();
        }
      }
      return customerName || '';
    },
    getCurrentOrderId(): number {
      return this.currentOrderId || 0;
    },
    getPaymentType(): number {
      const paymentType = Number(localStorage.getItem('paymentType') || 0);
      return paymentType;
    },
  }, //字段修改
  actions: {
    setCartNum(num: number) {
      this.cartNum = num;
    },
    setShopId(id: number) {
      this.shopId = id;
      localStorage.setItem('shopId', id.toString());
    },
    setShopName(name: string) {
      this.shopName = name;
      localStorage.setItem('shopName', name);
    },
    setCartType(type: number) {
      this.cartType = type;
      localStorage.setItem('cartType', type.toString());
    },
    setTableId(id: number) {
      this.tableId = id;
      localStorage.setItem('tableId', id.toString());
    },
    setTableName(name: string) {
      this.tableName = name;
      localStorage.setItem('tableName', name);
    },
    setQrCode(code: string) {
      this.qrCode = code;
      localStorage.setItem('qrCode', code);
    },
    setcustomerId(id: number | null) {
      if (id !== null) {
        this.customerId = id;
      }
    },
    setcustomerName(name: string) {
      this.customerName = name;
    },
    setCurrentOrderId(id: number) {
      this.currentOrderId = id;
    },
    setPaymentType(paymentType: number) {
      this.paymentType = paymentType;
      localStorage.setItem('paymentType', paymentType.toString());
    },
    getCarTag(): string {
      return this.getCartType === 1
        ? this.getShopName + '-' + this.getTableName
        : this.getcustomerName;
    },
  },
});

export default useMainStore;
